export default __webpack_public_path__ + "static/media/rare6.b034b72a.gif";